import { useSelector } from 'react-redux';
import { selectors } from "../../redux";

const useConfigHash = () => {
    return useSelector(selectors.configHash.getConfigHash);
}

export default useConfigHash;